import * as React from 'react';
import { I18n } from 'react-redux-i18n';

import { Loading } from '@common/components/loading';

import { TextEdit } from '../../../text-edit';
import { TextField } from '../../../text-field';
import { BackBtn } from '../../../back-btn';
import { Subtitle } from '../../../subtitle';

import { useHalfSiblingPageController } from './half-sibling-page.controller';
import { HalfSiblingPageProps } from './half-sibling-page.types';

import './half-sibling-page.styles.scss';

export const HalfSiblingPage: React.FC<HalfSiblingPageProps> = (props) => {
  const { cachedData, onGoBack, errors } = props;

  const {
    loadingPage,
    handlePageNameChange,
    handlePageDescriptionChange,
  } = useHalfSiblingPageController(props);
  
  if (loadingPage || !cachedData) {
    return (
      <div className="FhqDesignToolQuestionnaireDesignerPage">
        <Loading size={20} margin="20px" />
      </div>
    );
  }

  return (
    <div className="FhqDesignToolQuestionnaireDesignerHalfSiblingPage">
      <BackBtn className="FhqDesignToolQuestionnaireDesignerHalfSiblingPage__back-btn" onClick={onGoBack} />
      <TextEdit 
        errors={errors?.properties?.title}
        required
        metadata={{
          description: 'page-name',
        }}
        value={cachedData.title}
        onChange={handlePageNameChange}
      />
      <Subtitle type="chip" text={I18n.t('Half-Siblings')} />
      <TextField 
        metadata={{
          description: 'page-description',
        }}
        type="textarea"
        classes={{
          label: 'FhqDesignToolQuestionnaireDesignerHalfSiblingPage__description-label',
          labelInputWrapper: 'FhqDesignToolQuestionnaireDesignerHalfSiblingPage__description-input-label-wrapper',
          input: 'FhqDesignToolQuestionnaireDesignerCousinPage__description-input'
        }}
        label={I18n.t('Page Description')}
        value={cachedData.description ?? ''}
        onChange={handlePageDescriptionChange}
      />
    </div>
  );
};